// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__t0jbT","content":"styles_content__1-oeV"};